module.exports = __webpack_public_path__ + "img/thumbnail_Capybara_j_albino.2bf71a01.png";